document.addEventListener('DOMContentLoaded', () => {
  const swiperEl = document.querySelector('.video-slider');
  if (!swiperEl) return;

  const container = document.querySelector('#video-slider');
  const autoplayEnabled = container?.dataset.autoplay === 'true';

  let video_swiper;

  /* -----------------------------------
     Utility: Check if swiper overflows
  ------------------------------------ */
  function swiperOverflows(el) {
    const wrapper = el.querySelector('.swiper-wrapper');
    return wrapper.scrollWidth > el.clientWidth;
  }

  /* -----------------------------------
     Utility: Safe video play
  ------------------------------------ */
  function playWhenReady(video) {
    if (!video) return;

    // Autoplay compliance
    video.muted = true;
    video.playsInline = true;

    const tryPlay = () => {
      const promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(() => {});
      }
    };

    // If enough data is ready, play now; otherwise wait
    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('loadeddata', tryPlay, { once: true });
      video.addEventListener('canplay', tryPlay, { once: true });
      // Kick-start loading if needed
      if (typeof video.load === 'function') video.load();
    }
  }

  /* -----------------------------------
     Pause all videos in THIS slider only
  ------------------------------------ */
  function pauseAllVideosInSlider() {
    const videos = swiperEl.querySelectorAll('video');
    videos.forEach(v => {
      v.pause();
      // Optional: rewind all (usually NOT recommended)
      // v.currentTime = 0;
    });
  }

  function resetPlayIcons() {
    container?.querySelectorAll('.video-play-btn').forEach(btn => {
      btn.querySelector('.play-icon')?.classList.remove('tw-hidden');
      btn.querySelector('.pause-icon')?.classList.add('tw-hidden');
    });
  }

  /* -----------------------------------
     Play only the active slide video
  ------------------------------------ */
  function playActiveSlideVideo(swiper) {
    if (!autoplayEnabled || !swiper) return;

    const activeSlide = swiper.slides[swiper.activeIndex];
    const activeVideo = activeSlide?.querySelector('video');

    if (activeVideo) {
      playWhenReady(activeVideo);
    }
  }

  /* -----------------------------------
     Handle Slide Change
  ------------------------------------ */
  function handleSlideChange(swiper) {
    pauseAllVideosInSlider();
    resetPlayIcons();
    playActiveSlideVideo(swiper);
  }

  /* -----------------------------------
     Init Swiper
  ------------------------------------ */
  function initSwiper(shouldCenter) {
    return new Swiper(swiperEl, {
      speed: 400,
      spaceBetween: 19,

      // ✅ Start at first slide (not the middle)
      initialSlide: 0,

      slidesPerView: 'auto',
      centeredSlides: shouldCenter,
      centerInsufficientSlides: !shouldCenter,

      pagination: {
        el: container?.querySelector('.video-pagination') || '.video-pagination',
        clickable: true,
        type: 'bullets',
      },

      on: {
        afterInit(swiper) {
          // Ensure only active slide plays on load
          handleSlideChange(swiper);
        },

        // Fires when activeIndex changes (before/while transition)
        slideChange(swiper) {
          handleSlideChange(swiper);
        },

        // ✅ More reliable: also run after transition ends
        slideChangeTransitionEnd(swiper) {
          handleSlideChange(swiper);
        },
      },
    });
  }

  // Small delay to allow layout/images to settle
  setTimeout(() => {
    const shouldCenter = swiperOverflows(swiperEl);
    video_swiper = initSwiper(shouldCenter);
  }, 300);

  /* -----------------------------------
     Resize-safe re-evaluation
  ------------------------------------ */
  window.addEventListener('resize', () => {
    if (!video_swiper) return;

    const shouldCenter = swiperOverflows(swiperEl);

    if (shouldCenter !== video_swiper.params.centeredSlides) {
      video_swiper.destroy(true, true);
      video_swiper = initSwiper(shouldCenter);
    }
  });

  /* -----------------------------------
     Manual Play / Pause (only if autoplay disabled)
  ------------------------------------ */
  if (!autoplayEnabled) {
    const playButtons = container?.querySelectorAll('.video-play-btn') || [];

    playButtons.forEach(button => {
      button.addEventListener('click', async e => {
        e.preventDefault();
        e.stopPropagation();

        const slide = button.closest('.swiper-slide');
        const video = slide?.querySelector('video');
        if (!video) return;

        const playIcon = button.querySelector('.play-icon');
        const pauseIcon = button.querySelector('.pause-icon');

        try {
          if (video.paused) {
            // User interaction allows sound
            video.muted = false;
            video.playsInline = true;

            await video.play();

            playIcon?.classList.add('tw-hidden');
            pauseIcon?.classList.remove('tw-hidden');
          } else {
            video.pause();
            playIcon?.classList.remove('tw-hidden');
            pauseIcon?.classList.add('tw-hidden');
          }
        } catch (err) {
          playIcon?.classList.remove('tw-hidden');
          pauseIcon?.classList.add('tw-hidden');
        }
      });
    });
  }
});